import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import colors from '../../foundations/colors.module.scss';
import shadows from '../../foundations/shadows.module.scss';
import typography from '../../foundations/typography.module.scss';
export * from './MenuScrollbar.module.scss';
/**
 * Base menu paper styles used across TextField, InlineSelect, and other components.
 */ export const baseMenuPaperStyles = {
    backgroundColor: colors.white,
    borderRadius: 8,
    margin: '8px 0',
    boxShadow: shadows.sh60,
    border: "1px solid ".concat(colors.dark200)
};
/**
 * Base menu item styles used across TextField, InlineSelect, and other components.
 */ export const baseMenuItemStyles = {
    borderRadius: 4,
    margin: '2px 8px',
    transition: 'background-color 0.2s ease, color 0.2s ease',
    fontFamily: typography.fontFamilyLight,
    fontSize: typography.fontSizeP1,
    color: colors.dark700,
    padding: '8px 12px',
    minHeight: 'auto',
    opacity: 1,
    '&.Mui-selected': {
        backgroundColor: colors.dark100,
        color: "".concat(colors.dark900, " !important")
    },
    '&.Mui-disabled': {
        color: "".concat(colors.dark500, " !important"),
        backgroundColor: 'transparent !important',
        '&:hover': {
            backgroundColor: 'transparent !important'
        },
        '&.Mui-selected': {
            backgroundColor: 'transparent !important'
        }
    },
    '&.Mui-focusVisible:not(.Mui-selected)': {
        backgroundColor: colors.dark70
    },
    '& .MuiTouchRipple-root': {
        display: 'none'
    },
    '&:hover:not(.Mui-selected):not(.Mui-disabled)': {
        backgroundColor: colors.dark70
    },
    '&:active:not(.Mui-selected):not(.Mui-disabled)': {
        backgroundColor: colors.dark100
    },
    '&:first-child': {
        marginTop: 0
    },
    '&:last-child': {
        marginBottom: 0
    }
};
export const menuStyles = {
    '&.MuiPaper-root': baseMenuPaperStyles,
    '& .MuiMenuItem-root': baseMenuItemStyles
};
/**
 * Base menu styles hook for use in components.
 * Returns styles that include both menu paper and menu item styles.
 */ export const useBaseMenuStyles = function useBaseMenuStyles() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        menu: _object_spread({
            maxHeight: props.menuMaxHeight
        }, menuStyles),
        menuPaper: baseMenuPaperStyles,
        menuItem: baseMenuItemStyles
    };
};
